import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const usePersistedFilters = ({ options, onFilterChange }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const getInitialFilters = () => {
    const initial = {}
    options.forEach(({ key, options }) => {
      const urlValue = searchParams.get(key)
      const matchedOption = options.find(opt => opt.value === (urlValue))
      initial[key] = matchedOption ?? options.find(opt => opt.default) ?? options[0]
    })
    return initial
  }

  const [filters, setFilters] = useState(getInitialFilters)

  useEffect(() => {
    const params = new URLSearchParams(searchParams)
    Object.entries(filters).forEach(([key, val]: any) => {
      const defaultValue = options.find(opt => opt.key === key).options.find(opt => opt.default)?.value ?? options.find(opt => opt.key === key)?.options[0].value

      if (val.value === defaultValue) params.delete(key)
      else params.set(key, val?.value ?? '')

    })
    setSearchParams(params, { replace: true })
  }, [filters])

  const handleFilterChange = (key: string, selectedOption: any) => {
    setFilters(prev => ({ ...prev, [key]: selectedOption }))
    onFilterChange([key], selectedOption)
  }

  return {
    filters,
    handleFilterChange,
  }
}
